import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const FootprintsIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M7 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm3.8.02a1 1 0 0 1 1.18.78l2 10a1 1 0 1 1-1.96.4l-2-10a1 1 0 0 1 .78-1.18Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default FootprintsIcon;
